import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

/**
 * Preview environment configuration.
 *
 * Runs Angular frontend locally (localhost:4200) while connecting to
 * deployed sandbox APIs. Useful for frontend development without
 * running backend services locally.
 *
 * Usage: pnpm dev:sandbox
 *    or: pnpm nx serve spogClient --configuration=preview
 */
export const environment = {
  gtmContainerId: 'GTM-WZXPXV73',
  analyticsEnv: 'preview',
  // userlaneProductId: 'spog-development',
  firebase: {
    apiKey: "AIzaSyBnZQjXNpmtRbgiQttcwpMXpaeSKSpK_K8",
    authDomain: "spog-gopher-preview-8780.firebaseapp.com",
    projectId: "spog-gopher-preview-8780",
    storageBucket: "spog-gopher-preview-8780.firebasestorage.app",
    messagingSenderId: "464153790117",
    appId: "1:464153790117:web:44e3df4db86419af81ef4c"
  },
  urls: {
    backendApi: 'https://spog-backend-464153790117.us-central1.run.app/api',
    ...sharedUrls,
  },
  production: false,
  revision: REVISION,
  version: VERSION,
};
